module.exports = __webpack_public_path__ + "img/latest_activity.7692a0d9.svg";